<template>
  <div class="error-block">Error: Component '{{ props.reference.collection }}' not found /
    registered.
  </div>
</template>

<script setup lang="ts">
import {TBlockReference} from '~/types/block-types'

const props = defineProps<{
  reference: TBlockReference,
}>()

</script>

<style scoped lang="postcss">
.error-block {
  padding-bottom: 2.5rem;
  text-align: center;
  color: rgb(220 38 38);
}
</style>
